
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/power",
      function () {
        return require("private-next-pages/power.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/power"])
      });
    }
  